export default {
  //获取验证码图片
  getCaptcha: {
    method: 'get',
    url: 'captcha'
  },
  //获取短信验证码
  sendSms: {
    method: 'post',
    url: 'send/sms'
  },
  //获取邮箱验证码
  sendEmail: {
    method: 'post',
    url: 'send/email'
  },
  login: {
    method: 'post',
    url: 'login'
  },
  smsLogin: {
    method: 'post',
    url: 'sms-login'
  },
  logout: {
    method: 'post',
    url: 'logout'
  },
  resetPassword: {
    method: 'post',
    url: 'password'
  },
  getPermissions: {
    method: 'get',
    url: 'permission'
  },
  getPermissionList: {
    method: 'get',
    url: 'permission/list',
  },
  addPermission: {
    method: 'post',
    url: 'permission/add',
  },
  getCompanyOption: {
    method: 'get',
    url: 'option/company'
  },
  getModelOption: {
    method: 'get',
    url: 'option/device-model'
  },
  getCompanyMacOption: {
    method: 'get',
    url: 'option/mac-company'
  },
  getDeviceBatchOption: {
    method: 'get',
    url: 'option/device-custom'
  },
}

